export default "__VITE_ASSET__5ZBBZFJj__"